import React, { useContext } from "react";
import { css } from "emotion";
import { BuildContext } from "../../context/BuildSpotlightState";
import Section from "../createNew/Section";
import BackgroundColorPicker from "../createNew/BackgroundColorPicker";
import { boxStyles } from "../../styles/theme";
import NextButton from "./NextButton";
import TitleBlock from "./TitleBlock";

const BackgroundBuilder = () => {
  const { setStage, setLastCompleted } = useContext(BuildContext);
  const handleClick = () => {
    setStage(5);
    setLastCompleted(5);
  };
  return (
    <div className={container}>
      <TitleBlock/>
      <Section>
        <BackgroundColorPicker />
      </Section>
      <NextButton handleClick={handleClick} />
    </div>
  );
};

export default BackgroundBuilder;

const container = css`
  padding: ${boxStyles.standardPadding};
  display: flex;
  flex-direction: column;
  align-items: center;
  
  @media screen and (min-width: ${boxStyles.desktopBreak}) {
    max-width: 500px;
  }
  
`;
